import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './InsightsTooltip.module.scss'

const TooltipRow = ({ fill, stroke, value, name, unit, fontSize }) => (
  <div className={styles.tooltipRow} style={{ fontSize }}>
    <svg width="8" height="8">
      <circle cx="4" cy="4" r="4" fill={stroke || fill}></circle>
    </svg>
    <span className={styles.tooltipLabel}>{name}</span> {unit === '$' ? unit : ''}
    <span className={styles.tooltipValue}>
      {formatNumberAsThousands(value)} {unit !== '$' ? unit : ''}
    </span>
  </div>
)

const Tooltip = ({ label, payload, fontSize = 12 }) => {
  return (
    <div className={styles.container}>
      <div className={styles.tooltipTitle}>{label}</div>
      {payload.map((p, i) => (
        <TooltipRow {...p} key={`${p.name}${i}`} fontSize={fontSize} />
      ))}
    </div>
  )
}

export default Tooltip
